import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UrlServices } from '../url.services';
import { GenericService, METHODS } from '../services.util';

@Injectable({
  providedIn: 'root'
})
export class InspectionRulesService {
  urlServices: UrlServices = new UrlServices();

  private apiUrl = environment.URL_API;

  constructor(public _genericService: GenericService) {
    }
  getCatalog(data: string): Observable<any> {
    const url = this.urlServices.inpectionsParamsDynamo;
    return this._genericService.genericCallServices(METHODS.POST, url, {"data": data} , null, null, true, true);
  }

  getQuestions(): Observable<any> {
    return this.getCatalog('questions');
  }

  getRules(): Observable<any> {
    return this.getCatalog('rules');
  }

  getProvinces(): Observable<any> {
    return this.getCatalog('provinceRestricted');
  }

  getVehicles(): Observable<any> {
    return this.getCatalog('vehicleRestricted');
  }
} 